/* eslint-disable complexity */
/* eslint-disable indent */
/* eslint-disable no-magic-numbers */
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
import Button from "@atlaskit/button";
import DynamicTable from "@atlaskit/dynamic-table";
import ArrowRightCircleIcon from "@atlaskit/icon/glyph/arrow-right-circle";
import CrossCircleIcon from "@atlaskit/icon/glyph/cross-circle";
import { PopupSelect } from "@atlaskit/select";
import Toggle from "@atlaskit/toggle";
import dayjs from "dayjs";
import React, { ReactElement } from "react";
import { Link } from "react-router-dom";
import { MessageContext } from "../../contexts/Message/MessageContext";
import API from "../../services/API";
import { Appointment, FreeTimeSlot, TimeSlotLength, User } from "./Appointment";
import "./Appointments.scss";
import { getAppointmentStatus } from "./get-appointment-status";
import { createHead } from "./TableCells";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Props {}

export enum QuerySort {
    asc = "ASC",
    desc = "DESC",
}
interface FiltersState {
    page: number;
    limit: number;
    sort?: QuerySort;
    afterDate?: number | null;
    beforeDate?: number | null;
}
export default function Appointments({ }: Props): ReactElement {
    const messageContext = React.useContext(MessageContext);
    const [isLoading, setIsLoading] = React.useState(true);
    const [reload, setReload] = React.useState(0);
    const [appointments, setAppointments] = React.useState<Appointment[]>([]);
    const [isLoadingCoaches, setIsLoadingCoaches] = React.useState(true);
    const [avaiableCoaches, setAvaiableCoaches] = React.useState<User[]>([]);
    const intialFiltersState: FiltersState = {
        page: 0,
        limit: 1000,
        sort: QuerySort.asc,
        afterDate: Math.round(new Date().getTime() / 1000),
        beforeDate: null,
    };
    const [filter, setFilters] = React.useState(intialFiltersState);

    const fullyCancel = async (id: number) => {
        try {
            await API.handleDeleteRequest<any, any>(
                null,
                `appointments/as_coach/${id}`
            );
        } catch (error) {
            messageContext.actions.setMessage({
                title: "Etwas ist schiefgelaufen. Der Termin konnte nicht abgesagt werden",
                isOpen: true,
                titleApparencce: "danger",
                buttons: [
                    {
                        buttonText: "OK",
                        onClick: () => messageContext.actions.closeModal(),
                    },
                ],
            });
        }
        setReload(Math.random());
        messageContext.actions.closeModal();
    };

    function reassignAppointment(value: string | undefined, id: number) {
        setIsLoading(true);
        API.handlePostRequest(
            { newCoach: value },
            `/appointments/care_team/${id}`
        )
            .then(() => {
                messageContext.actions.setMessage({
                    title: "Erfolgreich zugewiesen!",
                    isOpen: true,
                    buttons: [
                        {
                            buttonText: "OK",
                            onClick: () => messageContext.actions.closeModal(),
                        },
                    ],
                });
                setReload(Math.random());
            })
            .catch(() => {
                messageContext.actions.setMessage({
                    title: "Etwas ist schiefgelaufen. Der Termin konnte nicht zugewiesen werden",
                    isOpen: true,
                    titleApparencce: "danger",
                    buttons: [
                        {
                            buttonText: "OK",
                            onClick: () => messageContext.actions.closeModal(),
                        },
                    ],
                });
                setIsLoading(false);
            });
    }

    const toggleHistory = () => {
        if (!filter.beforeDate) {
            setFilters({
                ...intialFiltersState,
                afterDate: null,
                sort: QuerySort.desc,
                beforeDate: Math.round(new Date().getTime() / 1000),
            });
        }
        if (!filter.afterDate) {
            setFilters({
                ...intialFiltersState,
                beforeDate: null,
                afterDate: Math.round(new Date().getTime() / 1000),
            });
        }
    };

    const cancelAppointment = (id: number) => {
        messageContext.actions.setMessage({
            title: "Bist du dir sicher dass du diesen Termin absagen möchtest?",
            isOpen: true,
            titleApparencce: "danger",
            buttons: [
                {
                    buttonText: "Ja",
                    onClick: () => fullyCancel(id),
                },
                {
                    buttonText: "Nein",
                    onClick: () => messageContext.actions.closeModal(),
                },
            ],
        });
    };
    React.useEffect(() => {
        setIsLoading(true);
        API.HandleGetRequest<Appointment[]>(
            `/appointments/coach?page=${filter.page}&limit=${filter.limit
            }&sort=${filter.sort}${filter.afterDate ? `&afterDate=${filter.afterDate}` : ""
            }${filter.beforeDate ? `&beforeDate=${filter.beforeDate}` : ""}`
        )
            .then((response) => {
                setAppointments(response);
                setIsLoading(false);
            })
            .catch((err) => {
                setIsLoading(false);
                messageContext.actions.setMessage({
                    title: "Etwas ist schiefgelaufen. Die Termine konnten nicht geladen werden",
                    isOpen: true,
                    titleApparencce: "danger",
                    buttons: [
                        {
                            buttonText: "OK",
                            onClick: () => messageContext.actions.closeModal(),
                        },
                    ],
                });
            });
    }, [filter, reload]);

    const getCoachesInTimeSlot = (time: number) => {
        setIsLoadingCoaches(true);
        API.HandleGetRequest<FreeTimeSlot[]>(
            "/booking/free_timeslots/coach"
        ).then((response) => {
            let timeSlotFound: FreeTimeSlot | undefined;

            response.forEach((timeSlot) => {
                if (
                    timeSlot.date ===
                    dayjs
                        .unix(parseInt(time as unknown as string, 10))
                        .add(15, "minute")
                        .unix()
                ) {
                    timeSlotFound = timeSlot;
                }
            });
            if (timeSlotFound) {
                API.handlePostRequest<any, User[]>(
                    { users: timeSlotFound.coaches },
                    "/users/multiple"
                ).then((responseCoaches) => {
                    setAvaiableCoaches(responseCoaches);
                    setIsLoadingCoaches(false);
                });
            } else {
                setAvaiableCoaches([]);
                setIsLoadingCoaches(false);
            }
        });
    };

    const getTableRows = (isAfter: boolean) =>
        appointments.map((appointment, index) => {
            const rows = {
                key: `row-${index}-${appointment.id}`,
                cells: [
                    {
                        key: "user.username",
                        content: (
                            <div>
                                <Link
                                    to={`/home/users/${appointment.user.userId}`}
                                >
                                    {appointment.user.username
                                        ? appointment.user.username
                                        : "<Kein Pseudonym>"}
                                </Link>
                            </div>
                        ),
                    },
                    {
                        key: "userInsuranceName",
                        content: (
                            <div>{appointment.userInsuranceName || "-"}</div>
                        ),
                    },
                    {
                        key: "datum",
                        content: dayjs
                            .unix(
                                parseInt(
                                    appointment.startDateTime as unknown as string,
                                    10
                                )
                            )
                            .format("DD.MM.YYYY"),
                    },
                    {
                        key: "prepare",
                        content: dayjs
                            .unix(
                                parseInt(
                                    appointment.startDateTime as unknown as string,
                                    10
                                )
                            )
                            .format("hh:mm A"),
                    },
                    {
                        key: "start",
                        content: dayjs
                            .unix(
                                parseInt(
                                    appointment.startDateTime as unknown as string,
                                    10
                                )
                            )
                            .add(15, "minute")
                            .format("hh:mm A"),
                    },
                    {
                        key: "end",
                        content: dayjs
                            .unix(
                                parseInt(
                                    appointment.startDateTime as unknown as string,
                                    10
                                )
                            )
                            .add(TimeSlotLength, "minute")
                            .format("hh:mm A"),
                    },
                    {
                        key: "status",
                        content: getAppointmentStatus(appointment),
                    },
                ],
            };

            if (!isAfter) {
                rows.cells.push({
                    key: "canceledAt",
                    content: appointment.canceledAt
                        ? dayjs(appointment.canceledAt).format(
                            "YYYY-MM-DD HH:mm"
                        )
                        : "Nicht bekannt",
                });
            }

            if (isAfter) {
                rows.cells.push({
                    key: "reassign",
                    content: (
                        <div className="appointment-icon-wrapper">
                            <PopupSelect
                                onChange={(option) => {
                                    reassignAppointment(
                                        option?.value,
                                        appointment.id
                                    );
                                }}
                                isMulti={false}
                                options={avaiableCoaches.map((coach) => ({
                                    label: coach.username,
                                    value: coach.userId,
                                }))}
                                closeMenuOnSelect={true}
                                target={({ isOpen, ...triggerProps }) => (
                                    <Button
                                        onClick={() =>
                                            getCoachesInTimeSlot(
                                                appointment.startDateTime
                                            )
                                        }
                                        {...triggerProps}
                                    >
                                        <ArrowRightCircleIcon
                                            {...triggerProps}
                                            primaryColor="#0052CC"
                                            label=""
                                        />
                                    </Button>
                                )}
                                popperProps={{
                                    placement: "bottom",
                                    strategy: "fixed",
                                }}
                                isLoading={isLoadingCoaches}
                            />
                        </div>
                    ) as unknown as string,
                });
                rows.cells.push({
                    key: "cancel",
                    content: (
                        <div className="appointment-cancel">
                            <div
                                onClick={() => {
                                    cancelAppointment(appointment.id);
                                }}
                            >
                                <CrossCircleIcon
                                    primaryColor="#FF5630"
                                    label=""
                                />
                            </div>
                        </div>
                    ) as unknown as string,
                });
            }
            return rows;
        });

    return (
        <div className="appointment-wrapper">
            <DynamicTable
                caption={
                    <div className="caption-wrapper">
                        Termine
                        <div className="appointment-load-history">
                            <small>Vergangene Termine anzeigen</small>
                            <Toggle
                                onChange={toggleHistory}
                                size="large"
                                label="Allow pull request"
                            />
                        </div>
                    </div>
                }
                isLoading={isLoading}
                head={createHead(Boolean(filter.afterDate))}
                rows={getTableRows(Boolean(filter.afterDate))}
                rowsPerPage={10}
                page={filter.page}
                defaultPage={1}
                isFixedSize
            />
        </div>
    );
}
